import { decodeFont } from '@rive-app/react-canvas';

const getFont = (asset): void => {
  fetch('/fonts/Inter-Font.ttf').then(async (res) => {
    const font = await decodeFont(new Uint8Array(await res.arrayBuffer()));
    asset.setFont(font);
    font.unref();
  });
};

export const onAssetLoad = (asset, bytes): boolean => {
  if (asset.cdnUuid.length > 0 || bytes.length > 0) {
    return false;
  }

  if (asset.isFont) {
    getFont(asset);
    return true;
  }

  return false;
};
